import { ICmsProductIntroEntity } from '@maia/shared';
import { ICmsProductDetailsEntity } from '../entitites/cms.entity';

export class CmsProductIntroDto {
  readonly identifier: string;
  readonly elements: Array<{
    readonly identifier:
      | string
      | 'tags_tag'
      | 'product_tagline'
      | 'lists_insured-box';
    readonly fields: Array<{
      readonly key: 'content' | 'title' | 'type';
      readonly value: string;
    }>;
    readonly elements: Array<{
      readonly identifier: string;
      readonly markdown: string | null;
    }>;
    readonly markdown: string | null;
    readonly links: [];
  }>;

  constructor(entity: ICmsProductIntroEntity) {
    this.identifier = entity.identifier;
    this.elements = entity.elements?.map((element) => ({
      identifier: element.identifier,
      fields: element.custom_fields.map((field) => ({
        key: field.key,
        value: field.value,
      })),
      elements: element.child_elements?.map((childElement) => ({
        identifier: childElement.identifier,
        markdown: childElement.markdown,
      })),
      markdown: element.markdown,
      links: element.links,
    }));
  }
}

export class CmsProductDetailsDto {
  readonly identifier: string;
  readonly guid: string;
  readonly elements: Array<{
    readonly identifier: 'details_title' | 'lists_checklist' | 'content' | '';
    readonly fields: Array<{
      readonly key: 'content' | 'title' | 'subTitle' | 'included';
      readonly value: string;
    }>;
    readonly elements: Array<{
      readonly identifier: string;
      readonly markdown: string | null;
    }>;
    readonly markdown: string | null;
    readonly links: [];
  }>;

  constructor(entity: ICmsProductDetailsEntity) {
    this.identifier = entity.identifier;
    this.guid = entity.guid;
    this.elements = entity.elements?.map((element) => ({
      identifier: element.identifier,
      fields: element.custom_fields.map((field) => ({
        key: field.key,
        value: field.value,
      })),
      elements: element.child_elements?.map((childElement) => ({
        identifier: childElement.identifier,
        markdown: childElement.markdown,
      })),
      markdown: element.markdown,
      links: element.links,
    }));
  }
}
